import LocalStorage from "./LocalStorage";
import ServerResponseModel from "./ServerResponseModel";

export default class Ws {

    // loginServerAddress = 'http://192.168.100.2:4444/api/'
    // adresaMedia = `http://192.168.100.2:4444/Storage/Media`

    // loginServerAddress = 'http://89.44.121.117:12000/api/'
    // adresaMedia = `http://89.44.121.117:12000/Storage/Media`

    loginServerAddress = 'https://proiecte.totalsoftware.ro/api/'
    adresaMedia = `https://proiecte.totalsoftware.ro/Storage/Media`
    adresaDownloadBilant = `https://proiecte.totalsoftware.ro/Storage/Media/Importuri`
    appVersion = '1.0'


    // buletin  `https://proiecte.totalsoftware.ro/Storage/Media/Angajati/Ci`
    // aviz https://proiecte.totalsoftware.ro/Storage/Media/Angajati/Avize
    // contract munca https://proiecte.totalsoftware.ro/Storage/Media/Angajati/Contracte
    // companie regulamente https://proiecte.totalsoftware.ro/Storage/Media/Companie/Regulamente

    // reactPostRef = 'dh839dnasjddty'

    update = async (tabela, cols, where) => {

        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'Update'
        po.postDataHeader.Tabela = tabela
        po.columns = cols
        po.where = where
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null, true)
        // console.log('r :', r);
        if (r.Succes) {
            return r
        }

    }

    proc = async (procName, parametrii) => {
        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'Proc'
        po.postDataHeader.Tabela = procName
        po.columns = parametrii
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null, true)

        // console.log('r :', r);

        if (r.Succes) {
            return r
        }
    }



    insert = async (tabela, cols) => {
        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'Insert'
        po.postDataHeader.Tabela = tabela
        po.columns = cols
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null, true)

        // console.log('r :', r);
        if (r.Succes) {
            return r
        }
    }

   

    uploadimage = async (adresa, file, id, idProiect = null, tip = null, idCost = null, idBuget = null) => {


        //adresa = if angajat
        // 
        if (idProiect) {
            let userData = this.getUserData();

            if (userData.UserToken && userData.AdresaServer) {



                let addr = `${userData.AdresaServer}${adresa}/?UserToken=${userData.UserToken}&id=${id}&idProiect=${idProiect}`


                if (tip) {
                    addr += `&tip=${tip}`
                }

                if (idCost) {
                    addr += `&idCost=${idCost}`
                }

                if (idBuget) {
                    addr += `&idBuget=${idBuget}`
                }


                let formData = new FormData();
                formData.append('file', file);

                // console.warn('formData :', formData);

                addr = encodeURI(addr)

                let fromServer = await fetch(addr, { method: 'POST', body: formData })

                let serverResponseAsJson = await fromServer.json()
                //let serverResponseAsJson = await fromServer.text()

                // console.log('fromServer :', serverResponseAsJson);

                // if(fromServer.status === 200){
                //    return true
                // }else{
                //     return false
                // }

                return serverResponseAsJson
            }
        } else {

            let userData = this.getUserData();

            if (userData.UserToken && userData.AdresaServer) {

                let addr = `${userData.AdresaServer}${adresa}/?UserToken=${userData.UserToken}&id=${id}`


                let formData = new FormData();
                formData.append('file', file);

                // console.warn('formData :', formData);

                addr = encodeURI(addr)

                let fromServer = await fetch(addr, { method: 'POST', body: formData })

                let serverResponseAsJson = await fromServer.json()
                //let serverResponseAsJson = await fromServer.text()

                // console.log('fromServer :', serverResponseAsJson);

                // if(fromServer.status === 200){
                //    return true
                // }else{
                //     return false
                // }

                return serverResponseAsJson
            }
            // let serverResponseAsJson = await fromServer.json()


        }

    }



    downloadFile = async(scop, id) =>{
        let userData = this.getUserData();
        if (userData.UserToken && userData.AdresaServer) {

            let addr = `${userData.AdresaServer}Download/GetFile/?UserToken=${userData.UserToken}&scop=${scop}&id=${id}`

            // window.open(addr)

            var link = document.createElement("a");
            // If you don't know the name or want to use
            // the webserver default set name = ''
            link.setAttribute('download', 'file');
            link.href = addr;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }


    uploadCostRow = async (adresa, file, idCost=null , idBuget = null) => {
        let userData = this.getUserData();

        if (userData.UserToken && userData.AdresaServer) {



            let addr = `${userData.AdresaServer}${adresa}/?UserToken=${userData.UserToken}`


            if(idCost){
                addr += `&idRowCost=${idCost}`
            }else {
                addr += `&idRowBuget=${idBuget}`
            }
            

            let formData = new FormData();
            formData.append('file', file);

            // console.warn('formData :', formData);

            addr = encodeURI(addr)

            let fromServer = await fetch(addr, { method: 'POST', body: formData })

            let serverResponseAsJson = await fromServer.json()
            //let serverResponseAsJson = await fromServer.text()

            // console.log('fromServer :', serverResponseAsJson);

            // if(fromServer.status === 200){
            //    return true
            // }else{
            //     return false
            // }

            return serverResponseAsJson
        }
    }


    uploadClient = async (adresa, file, an, luna) => {


        //adresa = if angajat
        // 

        let userData = this.getUserData();

        if (userData.UserToken && userData.AdresaServer) {

            let addr = `${userData.AdresaServer}${adresa}/?UserToken=${userData.UserToken}&an=${an}&luna=${luna}`


            let formData = new FormData();
            formData.append('file', file);

            // console.warn('formData clien', formData)

            addr = encodeURI(addr)

            let fromServer = await fetch(addr, { method: 'POST', body: formData })

            let serverResponseAsJson = await fromServer.json()
            //let serverResponseAsJson = await fromServer.text()

            // console.log('fromServer :', serverResponseAsJson);

            // if(fromServer.status === 200){
            //    return true
            // }else{
            //     return false
            // }

            return serverResponseAsJson
        }
        // let serverResponseAsJson = await fromServer.json()


    }

    uploadbalanta = async (adresa, file, an) => {


        //adresa = if angajat
        // 

        let userData = this.getUserData();

        if (userData.UserToken && userData.AdresaServer) {

            let addr = `${userData.AdresaServer}${adresa}/?UserToken=${userData.UserToken}&an=${an}`


            let formData = new FormData();
            formData.append('file', file);

            addr = encodeURI(addr)

            let fromServer = await fetch(addr, { method: 'POST', body: formData })

            let serverResponseAsJson = await fromServer.json()
            //let serverResponseAsJson = await fromServer.text()

            // console.log('fromServer :', serverResponseAsJson);

            // if(fromServer.status === 200){
            //    return true
            // }else{
            //     return false
            // }

            return serverResponseAsJson
        }
        // let serverResponseAsJson = await fromServer.json()


    }

    uploadbilant = async (adresa, file, an) => {


        //adresa = if angajat
        // 

        let userData = this.getUserData();

        if (userData.UserToken && userData.AdresaServer) {

            let addr = `${userData.AdresaServer}${adresa}/?UserToken=${userData.UserToken}&an=${an}&tip=micro`


            let formData = new FormData();
            formData.append('file', file);

            addr = encodeURI(addr)

            let fromServer = await fetch(addr, { method: 'POST', body: formData })

            let serverResponseAsJson = await fromServer.json()
            //let serverResponseAsJson = await fromServer.text()

            // console.log('fromServer :', serverResponseAsJson);

            // if(fromServer.status === 200){
            //    return true
            // }else{
            //     return false
            // }

            return serverResponseAsJson
        }
        // let serverResponseAsJson = await fromServer.json()


    }

    select = async (tabela, cols, where) => {
        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'Select'
        po.postDataHeader.Tabela = tabela
        po.columns = cols
        po.where = where
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null, true)

        if (r.Succes) {
            return r
        }
    }

    customSelect = async (q, params) => {
        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'SelectComplex'

        po.custselect = q
        po.custparams = params
        po.postDataHeader.Ref = this.reactPostRef


        let r = await this.postToJsTruster(po, null, true)

        console.log('r :', r);
        if (r.Succes) {
            return r
        }
    }

    postData = async (adresa, postObject, params = null, activeLog = null, text = null) => {

        let userData = this.getUserData();

        if (userData.UserToken && userData.AdresaServer) {

            if (postObject.postDataHeader.Scop) {

                let addr = userData.AdresaServer + adresa + '/?UserToken=' + userData.UserToken

                if (params) {
                    for (let k in params) {
                        addr += '&' + k + '=' + params[k]
                    }
                }

                addr = encodeURI(addr)

                //TODO: add post object as form data

                let formData = new FormData();
                formData.append('PostData', postObject);


                if (activeLog) {
                    // console.log('postData --> address = ', addr)
                    // console.log('Object to post = ', postObject)
                }

                // let r = await fetch(addr,{headers:{"Content-Type":"application/x-www-form-urlencoded"}, body:String.raw({raw:[formData]}) , method:'POST'})
                let r = await fetch(addr, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(postObject)
                })
                // console.log('raw string -----> :', String.raw({raw:['gogu']}));
                //  let r = new XMLHttpRequest();
                //  r.open("POST", addr, true);
                //  r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                //  r.send('sssss')



                //let r = await fetch(addr,{headers:{'cacat':'cacat'} ,method:'POST', body:formData})

                if (text) {

                    // console.log('await r.text() :', await r.text());
                } else {

                    let rjs = await r.json()
                    let sR = new ServerResponseModel()

                    if (sR.statusCode(r.status)) {


                        // console.log('response is ------- :', r);
                        return rjs
                    } else {
                        console.error('error status code', r)
                    }
                }





                if (activeLog) {
                    // console.log('postData --> server response = ', r)
                    // console.log('postData --> response Status :', r.status);

                    // console.log('postData --> readable server response = ', rjs)
                }





            }
            else {
                console.error('postObject.headerData.Scop is null')
                return null;
            }


        }
        else {
            console.error("userData is null ? server ? token ?")
            return null;
        }
    }

    getData = async (adresa, params = null, activeLog = null) => {

        let userData = this.getUserData();

        if (userData.UserToken && userData.AdresaServer) {
            let addr = userData.AdresaServer + adresa + '/?UserToken=' + userData.UserToken

            if (params) {
                for (let k in params) {
                    addr += '&' + k + '=' + params[k]
                }
            }

            addr = encodeURI(addr)

            // console.log('addr :>> ', addr);

            if (activeLog) {
                // console.log('getData --> address = ', addr)
            }

            let r = await fetch(addr)

            if (activeLog) {
                // console.log('getData --> server response = ', r)
                // console.log('getData --> response Status :', r.status);
                let rjs = await r.text()
                // console.log('getData --> readable server response = ', rjs)
            }


            return await r.json()

        }
        else {
            console.error("userData is null ? server ? token ?")
        }
    }

    login = async (u, p) => {

        console.log('u :>> ', u);

        console.log('p :>> ', p);
        if (u && p) {
            let addr = this.loginServerAddress + 'Login/Loginup/?u=' + u + '&p=' + p
            //addr = encodeURIComponent(addr)

            // console.log("Addr = ", addr )
            let r = await fetch(addr)
            // console.log('Login response is: ' , r )
            // console.log('Login --> response Status :', r.status);

            let sR = new ServerResponseModel()
            // let rText = await r.text()

            // console.log('rText :>> ', rText);
            if (sR.statusCode(r.status)) {

                let rJson = await r.json();
                // console.log('Login text response is: ' , rJson )


                return rJson;
            } else {
                console.error('Error Server LogIn', r.status, r.statusText)
                return null
            }

            //    let rJson = await r.text();
        }
    }

    generatePostObject = () => {
        return {
            postDataHeader: {
                Scop: null, //Select, SelectComplex, Insert, Update
                Tabela: null, // numele tabelei
                Id: null,
                Ref: null, //---- if jsTruster --- dh839dnasjddty
            },
            columns: null,  //{c1: 'id_client', c2:'nume_client'}
            where: null,        //{id: ''}
            custselect: null, //query ex = 'Select * from clienti where userToken = @p1 ' ---- SelectComplex
            custparams: null //{p1: 'blah blah'} ---- SelectComplex
        }
    }


    postToJsTruster = (postObject, params = null, activeLog = null, text = null) => {
        let adaptedPostObject = postObject
        adaptedPostObject.postDataHeader.Ref = 'dh839dnasjddty'

        return this.postData('Jstruster/Crud', adaptedPostObject, params, activeLog, text)
    }

    getUserData = () => {
        let LS = new LocalStorage();
        return LS.GetUserData();
    }
}